import { useSearchParams, useNavigate } from "react-router";
import { DataImportWizard } from "./DataImportWizard";
import { type EntityType } from "./fieldDictionary";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export const ImportDataPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const entityParam = searchParams.get("entity") as EntityType | null;

  return (
    <div className="container mx-auto px-4 py-6 max-w-6xl">
      <div className="mb-4 flex items-center justify-between">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(-1)}
          className="text-xs text-muted-foreground hover:text-foreground gap-1.5 cursor-pointer"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Voltar
        </Button>
      </div>
      <DataImportWizard initialEntityFilter={entityParam || undefined} />
    </div>
  );
};

ImportDataPage.path = "/import";
